export default "__VITE_ASSET__V1ZYpwZc9C51fJhgOTS5xQ__"